import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"min-height":"50px"} }
const _hoisted_2 = {
  key: 0,
  class: "margin-top30px",
  style: {"color":"red"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_processing = _resolveComponent("processing")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ProperAllTextYourOrder,
    onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emit('close'))),
    footerType: "customize"
  }, {
    footer: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode(_component_cus_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close'))),
          class: "margin-right5px"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_cus_button, {
          type: "blue",
          disabled: !_ctx.agree,
          onClick: _ctx.pay
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.OrderPay), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]), [
          [_vShow, !_ctx.isProcessing]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode("div", null, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 16 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextPriceDifference), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`$${_ctx.initData.priceDifference}`), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.initData.oldIsZero===1)
            ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextOldZero), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_3,
        _createVNode(_component_el_checkbox, {
          class: "margin-right10px",
          modelValue: _ctx.agree,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.agree = $event))
        }, null, 8, ["modelValue"]),
        _createVNode("label", {
          style: {"font-size":"14px","cursor":"pointer"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.agree = !_ctx.agree)),
          innerHTML: _ctx.$wordList.OrderAgree
        }, null, 8, ["innerHTML"])
      ], 512), [
        [_vShow, !_ctx.isProcessing]
      ]),
      _withDirectives(_createVNode(_component_processing, {
        payJumpUrl: _ctx.payJump,
        onSuccess: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('success'))),
        onFailed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emit('close')))
      }, null, 8, ["payJumpUrl"]), [
        [_vShow, _ctx.isProcessing]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}